import { 
  LayoutDashboard, 
  CreditCard, 
  QrCode, 
  BarChart3, 
  Wallet, 
  Palette,
  Settings,
  LogOut,
  Menu,
  X,
  User
} from 'lucide-react'
import { useState, useEffect } from 'react'
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import SubscriptionExpiredModal from '../../components/SubscriptionExpiredModal'
import MobileBottomNav from './MobileBottomNav'
import './Dashboard.css'

export default function Dashboard() {
  const { currentUser, userProfile, logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const navItems = [
    { path: '/dashboard', icon: <LayoutDashboard size={20} />, label: 'Overview', end: true },
    { path: '/dashboard/edit', icon: <CreditCard size={20} />, label: 'Edit vCard' },
    { path: '/dashboard/qr', icon: <QrCode size={20} />, label: 'QR Code' },
    { path: '/dashboard/analytics', icon: <BarChart3 size={20} />, label: 'Analytics' },
    { path: '/dashboard/themes', icon: <Palette size={20} />, label: 'Themes' },
    { path: '/dashboard/billing', icon: <Wallet size={20} />, label: 'Billing' },
    { path: '/dashboard/settings', icon: <Settings size={20} />, label: 'Settings' }
  ]

  async function handleLogout() {
    try {
      await logout()
      navigate('/login')
    } catch (error) {
      console.error('Failed to logout:', error)
    }
  }

  // Check for plan expiration
  const isExpired = userProfile?.plan !== 'free' && userProfile?.expiresAt && userProfile.expiresAt.toDate() < new Date()
  const isBillingPage = location.pathname === '/dashboard/billing'

  return (
    <div className="dashboard">
      {/* Expiration Modal Overlay - Hide on Billing page so users can pay */}
      {isExpired && !isBillingPage && (
        <SubscriptionExpiredModal />
      )}

      {/* Mobile Header */}
      <header className="dashboard-mobile-header hide-desktop">
        <button 
          className="menu-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <span className="dashboard-title">Digital vCard</span>
        <div className="user-avatar-sm">
          {currentUser?.photoURL ? (
            <img src={currentUser.photoURL} alt="" />
          ) : (
            <User size={18} />
          )}
        </div>
      </header>

      {/* Sidebar */}
      <aside className={`dashboard-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src="/assets/logo/logo.png" alt="Digital vCard" className="logo-image" style={{ height: '32px' }} />
            <span>Digital vCard</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {currentUser?.photoURL ? (
                <img src={currentUser.photoURL} alt="" />
              ) : (
                <User size={20} />
              )}
            </div>
            <div className="user-details">
              <span className="user-name">
                {userProfile?.name || currentUser?.displayName || 'User'}
              </span>
              <span className="user-plan">
                {userProfile?.plan === 'free' ? 'Free Plan' : 'Pro Plan'}
              </span>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div 
          className="sidebar-overlay hide-desktop" 
          onClick={() => setSidebarOpen(false)} 
        />
      )}

      {/* Main Content */}
      <main className="dashboard-main">
        <Outlet />
      </main>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />
    </div>
  )
}
